import * as SidebarLink from 'components/sidebar/SidebarLink';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const ChaptersLinks = () => {
    const { access, accountId } = useCurrentAccount();
    const linkPath = `/accounts/${accountId}/chapters`;

    if (!access.pages.includes('chapters')) return null;

    return (
        <SidebarLink.Link to={linkPath}>
            <SidebarLink.LevelOne icon="sitemap" isActive={location.pathname.includes(linkPath)}>
                Chapters
            </SidebarLink.LevelOne>
        </SidebarLink.Link>
    );
};

export { ChaptersLinks };
